import {IEventLogService as IEventLogServiceInfra} from '@techsee/techsee-client-infra/lib/services/EventLogService';
//@ts-ignore
import {EVENT_SOURCES, EVENT_LEVELS} from '@techsee/techsee-common/lib/constants/event-logs.constants';
import isEmpty from 'lodash/isEmpty';
import {EventLogConstant} from '../constants/events/event-log.constant';
import {UrlUtilsService} from '@techsee/techsee-client-services/lib/services/UrlUtilsService';

export type EventSource = EVENT_SOURCES.backend | EVENT_SOURCES.client | EVENT_SOURCES.dashboard;

export interface EventLogParams {
    logType: string;
    accountId?: string;
    userId?: string;
    roomId?: string;
    meta?: any;
}

export interface IEventLogsService {
    room: string;

    debug(logParams: EventLogParams): Promise<void>;

    info(logParams: EventLogParams): Promise<void>;

    warn(logParams: EventLogParams): Promise<void>;

    error(logParams: EventLogParams): Promise<void>;
}

export class EventLogsService implements IEventLogsService {
    private readonly _logger: IEventLogServiceInfra;

    private readonly _eventSource: EventSource;

    private readonly _isObserve: string | undefined | null;

    private _room: string;

    constructor(logger: IEventLogServiceInfra, eventsSource: EventSource) {
        this._logger = logger;
        this._eventSource = eventsSource;
        this._isObserve = this._isObserver();
        this._room = EventLogConstant.NO_ROOM;
    }

    get room(): string {
        return this._room;
    }

    set room(room: string) {
        this._room = room || EventLogConstant.NO_ROOM;
    }

    _isObserver(): string | undefined | null {
        return UrlUtilsService.extractQueryParamValueFromUrl(window.location.href, 'observe');
    }

    debug(logParams: EventLogParams) {
        return this.createLogRecord(logParams, EVENT_LEVELS.debug);
    }

    info(logParams: EventLogParams) {
        return this.createLogRecord(logParams, EVENT_LEVELS.info);
    }

    warn(logParams: EventLogParams) {
        return this.createLogRecord(logParams, EVENT_LEVELS.warn);
    }

    error(logParams: EventLogParams) {
        return this.createLogRecord(logParams, EVENT_LEVELS.error);
    }

    private createLogRecord(logParams: EventLogParams, level: EVENT_LEVELS): Promise<void> {
        let meta = logParams.meta;

        if (this._isObserve) {
            meta = isEmpty(meta) ? {isObserve: true} : {...meta, isObserve: true};
        }

        return this._logger.addEventLog(
            logParams.logType,
            logParams.roomId || this.room,
            logParams.userId,
            logParams.accountId,
            level,
            this._eventSource,
            meta
        );
    }
}
